module.exports = __webpack_public_path__ + "static/media/logo-cargonz.286e55fb.png";